import Leads from "../components/leads/leads"
function Leadss(){
    return(
        <>
        <Leads/>
        </>
    )
}
export default Leadss